import { render, staticRenderFns } from "./ImobilizadoAcumuladoLine.vue?vue&type=template&id=04a9c155&scoped=true&"
import script from "./ImobilizadoAcumuladoLine.vue?vue&type=script&lang=js&"
export * from "./ImobilizadoAcumuladoLine.vue?vue&type=script&lang=js&"
import style0 from "./ImobilizadoAcumuladoLine.vue?vue&type=style&index=0&id=04a9c155&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a9c155",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VSelect})
